import { Control, FieldValues, FormState } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import Checkbox from '../../forms/Checkbox';
import { UserRole } from '../../../data/models/user-role.model';
import { UserGroup } from '../../../data/models/user-group.model';

interface RoleGroupsFormProps {
  role?: UserRole;
  groups: UserGroup[];
  control: Control<FieldValues, object>;
  formState: FormState<any>;
}

export default function RoleGroupsForm({
  role,
  groups,
  control,
  formState,
}: RoleGroupsFormProps) {
  const { t } = useTranslation('common');

  return (
    <>
      {groups.map((p) => {
        const desc = p.description ? ` (${p.description})` : '';
        return (
          <Checkbox
            key={p.userGroupID}
            label={`${p.userGroupName}${desc}`}
            name={`GroupID_${p.userGroupID}`}
            control={control}
          />
        );
      })}
    </>
  );
}
